import React from "react";
import casapasadena from "./casapasadena.json";
import "./casapasadena.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah";
import maple from "../../../asset/centerpoin/maple/maple";
import montana from "../../../asset/centerpoin/montana/montana";
const imageMap = {
  maple,
  montana,
  // Add other image arrays here if you have more sets
};

const Casapasadena = () => {
  return (
    <div className="casapasadena">
      <div className="container-casapasadena">
        <div className="header">
          <div className="judul-casapasadena">
            <div className="pink"></div>
            <span>Casa Pasadena</span>
          </div>
        </div>
        <div className="cardhome-container">
          {casapasadena.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Casapasadena;
